// extracted by mini-css-extract-plugin
export default {"mainPlayer":"style_mainPlayer__5cIud","containerPlayer":"style_containerPlayer__GaFcE"};